import { useQuery } from "@tanstack/react-query";
import { API_ENDPOINTS, isDebug } from "../config/environment";

// Hook pour récupérer le lien d'onboarding
export const useGetOnboardingLink = (exid: string | null) => {
  return useQuery({
    queryKey: ["onboardingLink", exid],
    queryFn: async () => {
      if (!exid) throw new Error("exid is required");

      const url = `${
        API_ENDPOINTS.GET_ONBOARDING_LINK
      }?extId=${encodeURIComponent(exid)}`;

      if (isDebug) {
        console.log("🌐 Appel API - GET_ONBOARDING_LINK:", url);
      }

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (isDebug) {
        console.log("📥 Réponse API - GET_ONBOARDING_LINK:", data);
      }

      return data;
    },
    enabled: !!exid,
  });
};

// Hook pour vérifier le résultat
export const useCheckResult = (
  exid: string | null,
  timestamp: string | null
) => {
  return useQuery({
    queryKey: ["checkResult", exid, timestamp],
    queryFn: async () => {
      if (!exid || !timestamp)
        throw new Error("exid and timestamp are required");

      const url = `${API_ENDPOINTS.CHECK_RESULT}?extId=${encodeURIComponent(
        exid
      )}&timestamp=${timestamp}`;

      if (isDebug) {
        console.log("🌐 Appel API - CHECK_RESULT:", url);
      }

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();

      if (isDebug) {
        console.log("📥 Réponse API - CHECK_RESULT:", data);
      }

      return data;
    },
    enabled: !!exid && !!timestamp,
  });
};
